export const ModulePropsOption = {
    origin: { type: Object },
    disabled: { type: Boolean, default: false },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;
